import { ReactNode, useEffect } from "react";
import { CloseIcon } from "./Icons";

interface IModalProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  onClose?: () => void;
  wide?: boolean;
}

export default function Modal({
  title,
  subtitle,
  children,
  footer,
  onClose,
  wide,
}: IModalProps) {
  // cerrar con escape y bloquear el scroll del fondo mientras esta abierto
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose?.();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div className={wide ? "modal modal--wide" : "modal"}>
        <div className="modal__head">
          <div className="modal__head-text">
            <h2 className="modal__title">{title}</h2>
            {subtitle && <p className="modal__sub">{subtitle}</p>}
          </div>

          {onClose && (
            <button type="button" className="modal__close" onClick={onClose}>
              <CloseIcon size={17} />
              <span className="sr-only">Cerrar</span>
            </button>
          )}
        </div>

        <div className="modal__body">{children}</div>

        {footer && <div className="modal__foot">{footer}</div>}
      </div>
    </div>
  );
}
